module.exports = __webpack_public_path__ + "img/Soccer.d5b46060.svg";